// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "@firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCcbHL2jYrslvb-c0FlD-Q_G3_wHQQZ-fw",
  authDomain: "moogchi.firebaseapp.com",
  projectId: "moogchi",
  storageBucket: "moogchi.appspot.com",
  messagingSenderId: "635020849832",
  appId: "1:635020849832:web:127b49adf46a54063f489d",
  measurementId: "G-BQNKPXX6M5",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export const auth = getAuth(app);

export const storage = getStorage(app);
